<script setup>
import { computed, onMounted } from 'vue';
import { OVERVIEW_METRICS } from '../constants';

import MetricCard from './overview/MetricCard.vue';
import CategoryMetricsContainer from './CategoryMetricsContainer.vue';
import { useMapGetter, useStore } from 'dashboard/composables/store';
import { useI18n } from 'vue-i18n';
const { t } = useI18n();

const agentStatus = useMapGetter('agents/getAgentStatus');
const statuses = useMapGetter('accountStatuses/getStatuses');
const store = useStore();

const agentStatusMetrics = computed(() => {
  let metric = {};
  Object.keys(agentStatus.value).forEach(key => {
    const status = statuses.value.find(item => item.key === key);
    const metricName = OVERVIEW_METRICS[key]
      ? t(`OVERVIEW_REPORTS.AGENT_STATUS.${OVERVIEW_METRICS[key]}`)
      : status?.description || key;
    metric[metricName] = agentStatus.value[key];
  });
  return metric;
});

onMounted(() => store.dispatch('accountStatuses/get'));
</script>

<template>
  <div class="flex flex-col items-center md:flex-row gap-4">
    <div class="flex-1 w-full max-w-full md:w-[60%] md:max-w-[60%]">
      <CategoryMetricsContainer />
    </div>
    <div class="flex-1 w-full max-w-full md:w-[40%] md:max-w-[40%]">
      <MetricCard :header="$t('OVERVIEW_REPORTS.AGENT_STATUS.HEADER')">
        <div
          v-for="(metric, name, index) in agentStatusMetrics"
          :key="index"
          class="flex-1 min-w-0 pb-2"
        >
          <h3 class="text-xs text-n-slate-11 whitespace-nowrap">
            {{ name }}
          </h3>
          <p class="text-n-slate-12 text-2xl mb-0 mt-1">
            {{ metric }}
          </p>
        </div>
      </MetricCard>
    </div>
  </div>
</template>
